const ɵ0 = function ($q, $rootScope, StorageService, authService) {
    var urls = ['auth'];
    var factory = {};
    factory.request = function (config) {
        var notInUrlArray = function () {
            for (var i = 0; i < urls.length; i++) {
                if (config.url.includes(urls[i])) {
                    return false;
                }
            }
            return true;
        };
        var baseurl = StorageService.get('baseurl');
        if (baseurl === null) {
            StorageService.set('baseurl', '');
            baseurl = StorageService.get('baseurl');
        }
        config.url = baseurl + angular.copy(config.url);
        // if(config.url.includes('rememberme')) {
        //     var refreshtoken = StorageService.getCookie('refreshtoken');
        //     if (angular.isDefined(refreshtoken)){
        //         config.headers.Authorization = 'Bearer ' + refreshtoken;
        //     }
        // }else {
        //     var userDetails = StorageService.get('userDetails');
        //     if (notInUrlArray() && angular.isDefined(userDetails) && (userDetails.accesstoken !== null)){
        //         config.headers.Authorization = 'Bearer ' + userDetails.accesstoken;
        //     }
        // }
        return config;
    };
    factory.response = function (res) {
        $rootScope.isOffline = angular.isDefined(res.data) && angular.isDefined(res.data.statusCode) && angular.equals(res.data.statusCode, '500') && (res.data.developerMsg !== null) && res.data.developerMsg.includes("I/O error");
        if (angular.copy($rootScope.isOffline)) {
            $rootScope.throwError(res.data);
        }
        // Remove after angular component migration
        $rootScope.isOnline = !angular.copy($rootScope.isOffline);
        if (authService.isOnline) {
            authService.setIsOnline(false);
        }
        else {
            authService.setIsOnline(true);
        }
        return res;
    };
    factory.responseError = function (res) {
        console.log('responseError : ', res);
        if (angular.equals(res.status, 401) || angular.equals(res.status, 406)) {
            /**
             * This method serves for invalidating session currently exists.
             * This method will be caught in app.js
             */
            $rootScope.$broadcast('sessionInvalidated');
        }
        return $q.reject(res);
    };
    return factory;
};
export const InterceptorService = ['$q',
    '$rootScope',
    'StorageService',
    'authService', ɵ0];
export { ɵ0 };
//# sourceMappingURL=interceptorService.js.map